import { render, staticRenderFns } from "./Closer-Detail.vue?vue&type=template&id=9635bf62"
import script from "./Closer-Detail.vue?vue&type=script&lang=js"
export * from "./Closer-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports